module.exports = __webpack_public_path__ + "img/flow1.3eff172f.png";